import React from 'react';

export default function LazyLoader() {
  return (
 
     <div className="lds-facebook"><div></div><div></div><div>
      </div>
    </div>
  );
}
